import React, { Component } from "react";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import { formatDate } from "../../../../utils/utils";
import withGlobalData from "../../common/withGlobalData";
import { getSoDeliveriesReservationComplete } from "../../../../services/sales/salesDeliveryService";
class SearchDeliveriesReserveComplete extends Component {
  state = { reload: this.props.globalData.reload, deliveries: [] };

  componentDidMount() {
    this.getSoDeliveriesData();
  }

  componentDidUpdate() {
    const { globalData } = this.props;
    const { reload } = this.state;
    if (globalData.reload !== reload) {
      this.getSoDeliveriesData();
      this.setState({ reload: globalData.reload });
    }
  }

  async getSoDeliveriesData() {
    const { warehouseID = 0 } = this.props;
    const response = await getSoDeliveriesReservationComplete(warehouseID);
    const { data } = response.data;
    this.setState({ open: false, deliveries: data.deliveries });
  }

  render() {
    const { deliveries } = this.state;
    const { onSelectDeliveryOrder } = this.props;
    return (
      <CustomDataTableSearch
        data={deliveries}
        onRefreshData={() => {
          this.getSalesOrders();
        }}
        onSelectedData={(rowData, originalEvent) => {
          onSelectDeliveryOrder(rowData);
        }}
        columns={[
          {
            field: "select",
            body: (rowData) => (
              <React.Fragment>
                <button
                  type="button"
                  className="btn btn-label-success btn-sm btn-pill btn-bold"
                  onClick={() => onSelectDeliveryOrder(rowData)}
                >
                  Select <i className="fas fa-angle-double-right"></i>
                </button>
              </React.Fragment>
            ),
          },
          {
            header: "Delivery ID",
            field: "ID",
            body: null,
            sortable: true,
            filter: true,
          },
          {
            header: "Delivery Date",
            field: "deliveryDate",
            body: (rowData) => formatDate(rowData.deliveryDate),
            sortable: true,
            filter: true,
          },
          {
            header: "Document Reference",
            field: "deliveryDocRef",
            body: null,
            sortable: true,
            filter: true,
          },
          {
            header: "Document Reference ID",
            body: (rowData) => (
              <React.Fragment>{rowData.salesOrderID}</React.Fragment>
            ),
            sortable: false,
            filter: false,
          },
          {
            header: "Customer Name",
            field: "customer.customerName",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis
                  text={rowData.customer.customerName}
                  maxLine="1"
                />
              </React.Fragment>
            ),
            sortable: true,
            filter: true,
          },
        ]}
      />
    );
  }
}

export default withGlobalData(SearchDeliveriesReserveComplete);
